<template>
    <div class="page-header align-items-start min-vh-100">
        <span class="mask bg-white"></span>
        <div class="container">
            <div class="row">
            <div class="notifications">
                <material-alert v-if="error" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                {{ error }}
                </material-alert>
            </div>
            <div class="col-lg-4 col-md-8 col-12 mx-auto">
                <div class="d-flex justify-content-center mt-5">
                <img src="../assets/img/logo-ordering.png" class="avatar avatar-md mb-3 border-radius-lg" alt="user1" />
                </div>
                <div class="card-body">
                    <div class="mt-7 mb-2">
                    <form role="form" class="text-start">
                        <div class="text-center">
                        <span>Enter one-time passcode to login</span>
                        </div>
                        <div id="otp" class="inputs d-flex flex-row justify-content-center mt-6" style="align-items: center;">
                        <span style="margin-top: 10px;" class="material-icons me-3 icon-color-green md-30">lock_open</span>
                        <v-otp-input
                            ref="inputEnterPasscode"
                            input-classes="otp-input"
                            separator=""
                            :num-inputs="4"
                            :should-auto-focus="true"
                            :is-input-num="true"
                            :conditionalClass="['one', 'two', 'three', 'four']"
                            :placeholder="['', '', '', '']"
                            @on-complete="handleOnCompleteAlreadyPasscode"
                            v-model="form.passcode"
                        />
                        </div>
                    </form>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div class="position-fixed top-1 end-1 z-index-2">
            <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date=""
                    :description="message" :icon="{ component: 'campaign', color: 'white' }" :color="snackbar"
                    :close-handler="closeSnackbar" />
        </div>
    </div>
</template>
  
<script>
    import MaterialAlert from "@/components/MaterialAlert.vue";
    import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
    import VOtpInput from "vue3-otp-input";
    import router from "@/router";
  
    export default {
        name: "enter-one-time-passcode",
        components: {
        MaterialAlert,
        MaterialSnackbar,
        VOtpInput
    },
    data() {
        return {
            form: {
                phone_code: '+65',
                phone_number: this.$route.query.phone,
                passcode: ''
            },
            snackbar: null,
            error: '',
            merchantCode: "",
            branchCode: ""
        };
    },
    mounted() {
        const merchantCode = localStorage.getItem("MERCHANT_CODE", "");
        this.merchantCode = merchantCode ? `/${merchantCode}` : "";
        const branchCode = localStorage.getItem("BRANCH_CODE", "");
        this.branchCode = branchCode ? `/${branchCode}` : "";
    },
    methods: {
        login: function () {
            // alert(this.form.phone_number);
            if(!this.form.phone_number) {
                this.snackbar = 'danger'
                this.message = "Phone number can not blank."
                this.setTimeOutNotification();
                return;
            }
            if(this.form.passcode == "") {
                this.snackbar = 'danger'
                this.message = "Passcode can not blank."
                this.setTimeOutNotification();
                return;
            }
            this.successful = false;
            this.loading = true;
            this.$store.dispatch("auth/loginByPhoneAndPasscode", this.form).then(
                (data) => {
                if (data != undefined && !data.result.isSuccess) {
                    this.snackbar = 'danger'
                    this.message = data.result.message
                    this.setTimeOutNotification();
                } else {
                    router.push(this.merchantCode + this.branchCode+"/order?memorize=1");
                }
                },
                (error) => {
                    console.log('ERROR' + error)
                }
            );
        },
        closeSnackbar() {
            this.snackbar = null;
        },
        handleOnCompleteAlreadyPasscode: function (value) {
            this.form.passcode = value;
            this.login();
        },
        setTimeOutNotification() {
            setTimeout(() => {
                this.snackbar = null;
            }, 3000);
        },
    },
  };
</script>
<style>
    .otp-input {
        width: 40px;
        height: 40px;
        padding: 5px;
        margin: 0 10px;
        font-size: 20px;
        border: none;
        border-bottom: 2px solid green;
        text-align: center;
        border-radius: 0px !important;
        background: none;
    }
    
    .form-control:disabled,
    .form-control[readonly] {
        padding: 2px !important;
    }
    
    .text-green {
        color: #f9dd4b;
    }
    
    .otp-input:focus {
        outline: none !important;
    }
    
    .otp-input::-webkit-inner-spin-button,
    .otp-input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    
    input::placeholder {
        font-size: 15px;
        text-align: center;
        font-weight: 600;
    }
</style>
  